/**
 * Splits the hero title into per-letter spans (grouped by word so words
 * never break mid-letter), then animates each letter in.
 */

export function splitToLetters(root: Element): HTMLElement[] {
  if (root.getAttribute('data-split') === '1') return [];
  root.setAttribute('data-split', '1');

  const out: HTMLElement[] = [];

  const walk = (node: Node) => {
    Array.from(node.childNodes).forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.nodeValue ?? '';
        const frag = document.createDocumentFragment();
        let i = 0;
        while (i < text.length) {
          if (text[i] === ' ') {
            const span = document.createElement('span');
            span.className = 'fx-letter space';
            span.textContent = ' ';
            frag.appendChild(span);
            out.push(span);
            i++;
          } else {
            const word = document.createElement('span');
            word.className = 'fx-word';
            while (i < text.length && text[i] !== ' ') {
              const span = document.createElement('span');
              span.className = 'fx-letter';
              span.textContent = text[i] ?? '';
              word.appendChild(span);
              out.push(span);
              i++;
            }
            frag.appendChild(word);
          }
        }
        node.replaceChild(frag, child);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        walk(child);
      }
    });
  };

  walk(root);
  return out;
}

export function revealLetters(letters: HTMLElement[], stepMs = 22, startDelayMs = 40) {
  letters.forEach((el, i) => {
    setTimeout(() => el.classList.add('in'), startDelayMs + i * stepMs);
  });
}
